import { en, enISO, fr, frISO } from './constants'

// Returns if is FR lang
export const isFR = (l: string): boolean => {
  return fr.some(_l => _l.toLowerCase() === l.toLowerCase())
}

// Returns if is EN lang
export const isEN = (l: string): boolean => {
  return en.some(_l => _l.toLowerCase() === l.toLowerCase())
}

// Returns if is ISO lang
export const isISOLanguage = (l: string): boolean => {
  return isFR(l) || isEN(l)
}

export const transformIntoISO = (language: string): string => {
  if (language.length == 5) {
    return language
  }
  if (isFR(language)) return frISO
  if (isEN(language)) return enISO
  return enISO
}

// Returns ISO lang in 2 characters (transco)
export const getMiniISO = function (l: string): string {
  // Fallback language
  let lng = 'en'

  if (isFR(l)) {
    lng = 'fr'
  } else if (isEN(l)) {
    lng = 'en'
  }

  return lng
}
